<template lang="pug">
  .resources.m-bottom-6
    .row.m-bottom-2.space-between.bottom.m-top-5
      h3.title-medium {{ innerI18n.t('krea.educationalContent.resources', {content: contentTypeTranslation}) }}
    v-popover.self-end(
      placement='top-start'
      :delay='{show: 100, hide: 600}'
      trigger='hover click'
      popoverClass='krea-actions-popover'
      :container='false'
    )
      button.row.middle.m-top-1.m-bottom-2(@click='showOrderResources' v-if='isProject && resourcesTotalCount > 1')
        simple-svg.dark-gray-icon.m-right-1(:filepath='orderIcon' width='18px' height='18px')
        h2.dark-gray.text-normal {{ innerI18n.t('krea.educationalContent.orderResources') }}
      template(slot='popover')
        actions(
          placement='start'
          :info='orderResourcesInfo'
        )
    .row.resources-grid(v-if='initialResourcesLoading')
      add-resource-card(addKreaResource :contentId='content.id')
      sk-resource-card(v-for='n in 3' :key='"item" + n')
    .row.resources-grid(v-else)
      add-resource-card(addKreaResource :contentId='content.id')
      resource-card.m-bottom-2(
        v-for='resource in resources'
        :key='resource.id'
        :resource='resource'
        noMargin
        :activeLanguage='activeLanguage'
      )
    .row.center.width-100(v-if='showMoreResources && !loadingResources')
      button.uppercase.text-small.blue(@click='getMoreResources') {{ innerI18n.t('detailProgram.showMore') }}
    .resources-grid.relative.row.middle.center.m-bottom-3(v-if='loadingResources')
      sk-resource-card(v-for='n in 4' :key='"item2" + n')
      loader.absolute.loader(size='inner')
</template>

<script>
import Actions from '@/components/Krea/Inputs/Actions/Actions'
import Loader from '@/components/Loader'
import AddResourceCard from '@/components/Krea/EducationalContent/AddResourceCard'
import ResourceCard from '@/components/Krea/EducationalContent/ResourceCard'
import SkResourceCard from '@/components/SkResourceCard'
import orderIcon from '@/assets/ic_order.svg'
import { innerI18n } from '../../../main'
import { mapActions, mapState } from 'vuex'
import { contentType } from '../../../utils/constants'

export default {
  components: {
    Actions,
    ResourceCard,
    AddResourceCard,
    SkResourceCard,
    Loader
  },
  data() {
    return {
      orderIcon,
      innerI18n,
      resourcesPageNumber: 0,
      resourcesPageSize: 3,
      loadingResources: false,
      initialResourcesLoading: true
    }
  },
  watch: {
    activeLanguage() {
      this.reloadResources()
    }
  },
  async created() {
    await this.hydrateKreaEducationalContentResources({
      id: this.$route.params.id,
      pageNumber: this.resourcesPageNumber,
      pageSize: this.resourcesPageSize,
      locale: this.innerLocale || this.locale
    })
    this.initialResourcesLoading = false
  },
  computed: {
    ...mapState({
      content: state => state.kreaEducationalContent.content,
      resources: state => state.kreaEducationalContent.contentResources.resources,
      resourcesTotalCount: state => state.kreaEducationalContent.contentResources.totalCount,
      activeLanguage: state => state.kreaEducationalContent.activeLanguage,
      innerLocale: state => state.behavior.innerLocale,
      locale: state => state.behavior.locale
    }),
    kreaContentGuide() {
      return process.env[`VUE_APP_KREA_CREATE_CONTENT_GUIDE_${this.innerLocale}`]
    },
    contentTypeTranslation() {
      const contentTypeName = Object.keys(contentType).find(key => this.content.contentType === contentType[key])
      return innerI18n.t(`krea.educationalContent.${contentTypeName}`).toLowerCase()
    },
    isProject() {
      return this.content.contentType === contentType.project
    },
    showMoreResources() {
      return this.resources.length < this.resourcesTotalCount
    },
    orderResourcesInfo() {
      return {
        title: innerI18n.t('krea.educationalContent.orderResourcesInfoTitle'),
        guideLink: { msg: innerI18n.t('krea.educationalContent.details.contentGuideName'), link: this.kreaContentGuide },
        tips: [innerI18n.t('krea.educationalContent.orderResourcesInfo')]
      }
    }
  },
  beforeDestroy() {
    this.clearKreaEducationalContentResources()
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement',
      'updateKreaResourcesContentOrder',
      'hydrateKreaEducationalContentResources',
      'clearKreaEducationalContentResources'
    ]),
    async getMoreResources() {
      if (this.resourcesPageNumber === 0 && this.resourcesPageSize > 8) {
        this.resourcesPageSize = 4
      }
      this.resourcesPageNumber = this.resourcesPageNumber + 1
      this.loadingResources = true
      await this.hydrateKreaEducationalContentResources({
        id: this.$route.params.id,
        pageNumber: this.resourcesPageNumber,
        pageSize: this.resourcesPageSize,
        locale: this.activeLanguage
      })
      this.loadingResources = false
    },
    async reloadResources() {
      this.clearKreaEducationalContentResources()
      this.resourcesPageNumber = 0
      this.resourcesPageSize = 3
      this.initialResourcesLoading = true
      await this.hydrateKreaEducationalContentResources({
        id: this.$route.params.id,
        pageNumber: this.resourcesPageNumber,
        pageSize: this.resourcesPageSize,
        locale: this.activeLanguage
      })
      this.initialResourcesLoading = false
    },
    async updateResourcesOrder(resources) {
      await this.updateKreaResourcesContentOrder(resources)
      this.reloadResources()
    },
    showOrderResources() {
      this.showElement({
        element: 'orderResourcesModal',
        props: {
          resources: this.resources,
          confirmFunc: this.updateResourcesOrder
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.resources-grid{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 15px;
}
</style>
